import { Play, Tv, Brain, Flame, MessageCircle } from "lucide-react";

// Les 4 émissions de Jesus Talk (identité de marque)
export const SHOWS = [
  {
    id: "bibleflix",
    name: "BIBLEFLIX",
    subtitle: "Les Saisons de la Foi",
    tagline: "Te transformer série après série",
    icon: Tv,
    image: "https://images.unsplash.com/photo-1512446733611-9099a758e63c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    // desert / sand cinematic (Bibleflix aesthetic)
    gradient: "from-orange-950 via-orange-800 to-amber-600",
    accent: "#E88932",
  },
  {
    id: "deep-talks",
    name: "DEEP TALKS",
    subtitle: "Plonger dans la Parole",
    tagline: "Le podcast qui te plonge dans la Parole de Dieu",
    icon: Brain,
    image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    // Deep dark blue (Deep Talks aesthetic)
    gradient: "from-slate-950 via-blue-950 to-blue-900",
    accent: "#3B82F6",
  },
  {
    id: "wake-up",
    name: "WAKE UP",
    subtitle: "It's Time",
    tagline: "Le podcast qui réveille ta foi",
    icon: Flame,
    image: "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    // Ocean sunrise (Wake Up aesthetic)
    gradient: "from-blue-900 via-cyan-800 to-amber-500",
    accent: "#F4A94E",
  },
  {
    id: "talk-show",
    name: "LE TALK SHOW",
    subtitle: "Témoignages & Vie",
    tagline: "Le podcast de témoignages et discussions autour de la vie avec Dieu",
    icon: MessageCircle,
    image: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    // Warm studio (Talk Show aesthetic)
    gradient: "from-amber-950 via-yellow-900 to-yellow-700",
    accent: "#EAB308",
  },
];

export default function ShowsGrid({ dark = false, compact = false }) {
  return (
    <div data-testid="shows-grid" className={`grid gap-4 md:gap-5 grid-cols-2 lg:grid-cols-4 ${compact ? "" : ""}`}>
      {SHOWS.map((show, i) => {
        const Icon = show.icon;
        return (
          <a
            key={show.id}
            href="/podcasts"
            data-testid={`show-${show.id}`}
            className="group jt-card jt-poster block bg-black jt-medium-shadow"
            style={{ animationDelay: `${i * 100}ms` }}
          >
            <div className={`absolute inset-0 bg-gradient-to-br ${show.gradient}`} />
            <img
              src={show.image}
              alt={show.name}
              className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
              loading="lazy"
            />
            {/* TOP 10 badge */}
            <div className="absolute top-3 right-3 z-10 bg-[#E63946] text-white text-[10px] font-bold tracking-widest px-2 py-1 rounded-sm leading-none jt-red-glow">
              TOP<br />10
            </div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col justify-end p-4 md:p-5 text-white">
              <div className="mb-2">
                <div className="h-9 w-9 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center mb-3 group-hover:bg-[#E63946] transition-colors">
                  <Icon className="w-4 h-4" strokeWidth={2} />
                </div>
              </div>
              <h3 className="font-display text-2xl md:text-3xl leading-none tracking-wider" style={{ color: show.accent }}>
                {show.name}
              </h3>
              <p className="text-xs md:text-sm text-white/80 mt-1 uppercase tracking-wider">
                {show.subtitle}
              </p>
              <p className="text-[11px] md:text-xs text-white/60 mt-2 line-clamp-2">
                {show.tagline}
              </p>

              <div className="mt-3 inline-flex items-center gap-1.5 text-xs opacity-0 group-hover:opacity-100 transition-opacity translate-y-2 group-hover:translate-y-0">
                <Play className="w-3.5 h-3.5" />
                <span>Découvrir</span>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}
